/** Placeholders for Privacy Policy — update for production; optional REACT_APP_PRIVACY_EMAIL in .env */
export const PRIVACY_EMAIL =
  process.env.REACT_APP_PRIVACY_EMAIL || 'support@techelliptica.com';

export const LEGAL_ENTITY_NAME = 'Tellipticatraining';

export const BUSINESS_ADDRESS = 'Office Number 119, Mainland hub,Keshnand Road, Wagholi - 412207, Pune, Maharashtra, INDIA';

export const PRIVACY_LAST_UPDATED = 'April 6, 2026';
